module.exports = __webpack_public_path__ + "img/noImage.97f56537.png";